import type { ComponentProps } from 'react'
import * as React from 'react'
import { Popup } from 'react-map-gl/mapbox'

import type { LngLat } from 'lib/maps/types'

export interface MapboxPopupProps extends Omit<ComponentProps<typeof Popup>, 'latitude' | 'longitude'> {
  coordinate: LngLat
}

export function MapboxPopup({ coordinate, anchor = 'bottom', ...props }: MapboxPopupProps) {
  return (
    <Popup
      latitude={coordinate.lat}
      longitude={coordinate.lng}
      anchor={anchor}
      {...props}
    />
  )
}
